/**
 * The below file is the Fire Detection service which contains method for doing the API calls.
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import fetch from "auth/FetchInterceptor";
import {
  Application_Json,
  Authorization_Token,
  Get_All_Fire_Detection,
} from "constants/ApiConstant";
import { format } from "react-string-format";
import { AUTH_TOKEN } from "redux/constants/Auth";

const FireDetectionService = {};

//#region Method for Fire Detection dropdown

/**
 * Method for getting the Fire Detection dropdown
 * @param {any} param API Parameters
 * @returns Fetch Method
 */
FireDetectionService.getAllFireDetection = function () {
  return fetch({
    url: Get_All_Fire_Detection,
    method: "get",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
  });
};

//#endregion Method for Fire Detection dropdown.

export default FireDetectionService;
